import {
  Input,
  Inject,
  OnInit,
  Directive,
  HostListener,
} from 'ng-metadata/core';

import { DialogService } from 'services/dialog.service';



/**
 * Triggers open a Material dialog for authentication
 */
@Directive({
  selector: '[gw-auth-open]',
})
export class AuthOpenDirective {

  constructor(
    @Inject('$rootScope') private $rootScope: ng.IRootScopeService,
    @Inject(DialogService) private dialogService: DialogService,
  ) {}

  @HostListener('click', ['$event'])
  onClick($event) {
    // Close drops if any is open
    this.$rootScope.$broadcast('gw-close-drop');

    const dialog = this.dialogService.openUserAuth({}, $event);

    dialog.then((data: any) => {
      // If login was successful, reload page
      if (data && data.reload) {
        window.location.reload();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/directives/auth-open.directive.ts